import type { App } from '../../app/App';
import type { CollectionEventDependencies } from '../collectionEvent/CollectionEventController';
import type { CollectionEventConfig, CollectionEventInfo } from '../collectionEvent/types';
import type { ResourceMap } from '../../app/resources/types';
import { TransactionReason } from '../../app/resources/types';
import { MetaPopupStackController } from '../../metaAbstractions/createMetaPopupController';
import { ObservableValue } from '../../app/state/createObservableValue';
import { collectionEventConfig } from '../collectionEvent/collectionEventConfig';

export function createCollectionEventDependencies(app: App): CollectionEventDependencies {
  return {
    addResource(eventInfo: CollectionEventInfo, resources: ResourceMap): void {
      app.resources.makeTransaction(resources, TransactionReason.CollectionEventReward, {
        gameEventId: eventInfo.eventId,
      });
    },
    config: collectionEventConfig,
    observable: new ObservableValue(app.stateController, ['collectionEvent', 'language', 'levelIndex']),
    popupsController: new MetaPopupStackController(app.controller.popups),
    onEvent: {
      onTokensAdded: (config: CollectionEventConfig, tokens: number): void => {
        app.tracking.trackCollectionEventTokenUpdate({
          gameEventId: config.id,
          levelAttemptId: app.stateController.getData().levelAttemptId ?? '',
          metaProperties: [],
          tokenAmount: tokens,
        });
      },
      onEventFinished: (config: CollectionEventConfig, progress: number): void => {
        app.tracking.trackCollectionEventEnd({
          gameEventId: config.id,
          gameEventTier: progress,
        });
      },
    },
  };
}
